import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const connectionSettingsSchema = z.object({
  blackListedWifiNames: z.array(z.string()),
  isWifiOnly: z.boolean(),
  modifiedOn: coercedDate,
});

export type ConnectionSettings = z.infer<typeof connectionSettingsSchema>;
